<template>
  <ul
    class="checklist"
    :class="classObject"
  >
    <li
      v-for="item in items"
      :key="item"
      class="checklist__item"
    >
      <icon
        type="check"
        class="checklist__check"
      /> {{ item }}
    </li>
  </ul>
</template>

<script>
import icon from './icon.vue'

export default {
  name: 'CCheckList',

  components: {
    icon
  },

  props: {
    items: {
      type: Array,
      required: true
    },
    color: {
      type: String,
      default: undefined
    }
  },

  computed: {
    classObject () {
      return {
        'checklist--primary': this.color === 'primary',
        'checklist--primary-dark': this.color === 'primary-dark',
        'checklist--secondary': this.color === 'secondary',
        'checklist--secondary-dark': this.color === 'secondary-dark'
      }
    }
  }
}
</script>

<style lang="scss">
@import "../css/variables";

.checklist {
  padding: 0 0 0 1em;
}

.checklist__item {
  padding-left: 0.5em;
  text-indent: -1.5em;

  &::before {
    display: none;
  }
}

.checklist__check {
  margin-right: 0.25em;

  color: currentColor;

  .checklist--primary & {
    color: $color-primary;
  }

  .checklist--primary-dark & {
    color: $color-primary-dark;
  }

  .checklist--secondary & {
    color: $color-secondary;
  }

  .checklist--secondary-dark & {
    color: $color-secondary-dark;
  }
}
</style>
